<template>
  <section id="indexation" class="w-full flex-1">
    <h2 class="font-bold text-gray-900 border-b border-gray-400 pb-1">
      Indexation Calculation - {{ year }}
    </h2>
    <div class="mt-6 text-sm">
      <dd class="text-gray-600">Maximum Transfer Balance Account</dd>
      <dt class="font-medium text-gray-800">{{ maxTBA | dollar }}</dt>
    </div>
    <div class="mt-2 text-sm">
      <dd class="text-gray-600">Unused cap</dd>
      <dt class="font-medium text-gray-800">
        <!-- eslint-disable-next-line vue/no-parsing-error -->
        100% - {{ ratio | percent }} = {{ unused | percent }}
      </dt>
    </div>
    <div class="mt-2 text-sm">
      <dd class="text-gray-600">Indexation applicable</dd>
      <dt class="font-medium text-gray-800">{{ indexation | dollar }}</dt>
    </div>
    <div class="mt-2 text-sm">
      <dd class="text-gray-600">New Transfer Balance Cap (1 July {{ year }})</dd>
      <dt class="font-medium text-gray-800">{{ newTBC | dollar }}</dt>
    </div>
  </section>
</template>

<script>
export default {
  name: 'transfer-balance-cap-indexation',
  props: {
    maxTBA: {
      type: Number,
      required: true,
    },
    ratio: {
      type: Number,
      required: true,
    },
    unused: {
      type: Number,
      required: true,
    },
    indexation: {
      type: Number,
      required: true,
    },
    newTBC: {
      type: Number,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
  },
};
</script>
